export default __webpack_public_path__ + "static/media/screen5.ef8c020a.png";